<template>
  <div class="keyboard">
    <c-toolbar type="HATSU" />
    <div class="title" v-html="$t('keyboard.title')"></div>
    <div class="header-panel">
      <a-radio-group v-model="layerIndex" size="large">
        <a-radio-button
          v-for="index in layerNum"
          :key="index"
          :value="index - 1"
        >
          {{ $t("keyboard.layer") + " " + index }}
        </a-radio-button>
      </a-radio-group>
      <i
        class="add iconfont iconplus-o"
        v-if="layerNum < 7"
        @click="onAddLayer"
      />
      <i
        class="remove iconfont iconminus-o"
        v-if="layerIndex > 7"
        @click="onRemoveLayer"
      />
    </div>
    <div class="keyboard-panel">
      <c-keyboard-hatsu
        class="c-keyboard"
        :layer="layer"
        :layerIndex="layerIndex"
        :selectedIndex="selectedIndex"
        @key-click="onKeyClick"
      />
    </div>
    <div class="virtual-keyboard-panel">
      <c-virtual-keyboard-hatsu
        class="c-virtual-keyboard"
        v-if="selectedKeyIndex !== null"
        :selectedKey="layer[selectedKeyIndex]"
        :isLeft="selectedKeyIndex < 100"
        @key-click="onVirtualKeyClick"
      />
    </div>
    <div class="buttons">
      <div class="profile">{{ profileHatsu.fileName }}</div>
      <label class="upload button" for="file">
        <a-tooltip>
          <template slot="title">
            <span style="color: #fff;">{{ $t("downloadTip") }}</span>
          </template>
          {{ $t("download") }}
        </a-tooltip>
        <input id="file" type="file" @change="onUpload" accept=".json" />
      </label>
      <div class="button" @click="onDownload">
        <a-tooltip>
          <template slot="title">
            <span style="color: #fff;">{{ $t("saveTip") }}</span>
          </template>
          {{ $t("save") }}
        </a-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { download, deepCopy } from "@/utils";
export default {
  name: "KeyboardHatsu",
  data() {
    return {
      layerIndex: 0,
      selectedIndex: -2,
      selectedKeyIndex: null,
      FnKeys: [
        "#00920C0B",
        "#00920C0C",
        "#00920C0D",
        "#00920C0E",
        "#00920C0F",
        "#00920C10",
      ],
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState(["profileHatsu"]),
    layer() {
      return this.profileHatsu.data.key_layer.layer_data[this.layerIndex].layer;
    },
    layerNum() {
      return this.profileHatsu.data.key_layer.layer_num;
    },
  },
  methods: {
    onAddLayer() {
      let data = this.profileHatsu.data;
      data.key_layer.layer_num = this.layerNum + 1;
      data.key_layer.layer_data.push({
        layer: [...data.key_layer.layer_data[0].layer],
      });
      this.$store.dispatch("profileHatsu/setData", data);
      this.resyncFnKeys(0);
    },
    onRemoveLayer() {
      if (this.layerIndex === this.layerNum - 1) {
        this.layerIndex -= 1;
      }
      let data = this.profileHatsu.data;
      data.key_layer.layer_num = this.layerNum - 1;
      data.key_layer.layer_data.splice(this.layerIndex + 1, 1);
      this.$store.dispatch("profileHatsu/setData", data);
    },
    onKeyClick({ index, keyIndex }) {
      this.selectedKeyIndex = this.selectedIndex === index ? null : keyIndex;
      this.selectedIndex = this.selectedIndex === index ? -1 : index;
    },
    onVirtualKeyClick(key) {
      if (this.layer[this.selectedKeyIndex] === key) return;
      let data = deepCopy(this.profileHatsu.data);
      let layer = [...this.layer];
      // const keyNames = {
      //   "#00920C0B": "Fn Left",
      //   "#00920C0C": "Button Left",
      //   "#00920C0D": "FnS Left",
      //   "#00920C0E": "Fn Right",
      //   "#00920C0F": "Button Right",
      //   "#00920C10": "FnS Right",
      // };
      // if (this.FnKeys.includes(key)) {
      //   this.$confirm({
      //     title: this.$t("keyboard.addFn", [keyNames[key]]),
      //     width: "9.4rem",
      //     okText: this.$t("yes"),
      //     cancelText: this.$t("cancel"),
      //     centered: true,
      //     onOk: () => {
      //       layer[this.selectedKeyIndex] = key;
      //       data.key_layer.layer_data[this.layerIndex].layer = layer;
      //       this.$store.dispatch("profileHatsu/setData", data);
      //       this.resyncFnKeys(this.layerIndex);
      //     },
      //   });
      // } else if (this.FnKeys.includes(oldKey)) {
      //   this.$confirm({
      //     title: this.$t("keyboard.changeFn", [keyNames[oldKey]]),
      //     width: "9.4rem",
      //     okText: this.$t("yes"),
      //     cancelText: this.$t("cancel"),
      //     centered: true,
      //     onOk: () => {
      //       layer[this.selectedKeyIndex] = key;
      //       data.key_layer.layer_data[this.layerIndex].layer = layer;
      //       this.$store.dispatch("profileHatsu/setData", data);
      //       this.resyncFnKeys(this.layerIndex);
      //     },
      //   });
      // } else {
      const oldKey = layer[this.selectedKeyIndex];
      layer[this.selectedKeyIndex] = key;
      data.key_layer.layer_data[this.layerIndex].layer = layer;
      if (
        ["#00920C0D", "#00920C10"].includes(key) ||
        ["#00920C0D", "#00920C10"].includes(oldKey)
      ) {
        data.key_layer.layer_data.map((layer) => {
          layer.layer[this.selectedKeyIndex] = key;
        });
      }
      this.$store.dispatch("profileHatsu/setData", data);
      // }
    },
    resyncFnKeys(layerIndex) {
      const keys = {};
      let data = this.profileHatsu.data;
      data.key_layer.layer_data[layerIndex].layer.map((key, index) => {
        if (this.FnKeys.includes(key)) {
          keys[index] = key;
        }
      });
      data.key_layer.layer_data.map(({ layer }) => {
        layer.map((key, index) => {
          if (this.FnKeys.includes(key)) {
            layer[index] = "#00000000";
          }
        });
        for (const index in keys) {
          layer[index] = keys[index];
        }
      });
      this.$store.dispatch("profileHatsu/setData", data);
    },
    onUpload(e) {
      const file = e.target.files[0];
      if (file) {
        new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onerror = reject;
          fileReader.onload = (e) => {
            try {
              const data = JSON.parse(e.target.result);
              if (
                data &&
                data.product_info &&
                data.product_info.product_id === "HATSU"
              ) {
                resolve(data);
              } else {
                reject();
              }
            } catch (error) {
              reject(error);
            }
          };
          fileReader.readAsText(file);
        })
          .then((data) => {
            this.layerIndex = 0;
            this.$store.dispatch("profileHatsu/setData", data);
            this.$store.dispatch(
              "profileHatsu/setFileName",
              file.name.split(".")[0]
            );
            this.$store.dispatch("loader/syncMacroKey", {
              macro_key: data.macro_key,
              original_key: "",
            });
            e.target.value = null;
          })
          .catch(() => {
            e.target.value = null;
            this.$info({
              title: this.$t("index.fileErrorInfo"),
              width: "8.4rem",
              okText: this.$t("yes"),
              cancelText: this.$t("cancel"),
              centered: true,
            });
          });
      }
    },
    onDownload() {
      const file = new Blob([JSON.stringify(this.profileHatsu.data)]);
      const fileName = (this.profileHatsu.fileName + "-HATSU.json").replace(
        /-HATSU.+HATSU/,
        "-HATSU"
      );
      download(file, fileName);
    },
  },
};
</script>
<style lang="scss" scoped>
.keyboard {
  min-height: inherit;
  text-align: center;
  color: #ffffff;
  padding: 80px 0 400px 0;

  .title {
    font-size: 20px;
    margin-bottom: 30px;
  }

  .header-panel {
    @include flex-center;
    width: 1300px;
    margin: 0 auto 40px auto;
    justify-content: flex-start;

    .add,
    .remove {
      @include icon-hover;
      font-size: 30px;
      margin-left: 20px;
    }

    .remove {
      margin-left: 10px;
    }
  }

  .keyboard-panel {
    @include flex-center;
    margin-bottom: 20px;

    .c-keyboard {
      width: 1300px;
    }
  }

  .virtual-keyboard-panel {
    @include flex-center;
    margin-bottom: 60px;

    .c-virtual-keyboard {
      width: 1320px;
    }
  }

  .buttons {
    @include flex-center;

    .button {
      @include button;
      width: 180px;
      margin: 0 100px;

      span {
        font-size: 24px;
        line-height: 12px;
      }
    }

    .profile {
      @include nowrap;
      width: 140px;
      height: 42px;
      line-height: 42px;
      border: 1px solid $active-color;
      border-right: 0 !important;
      border-radius: 4px 0 0 4px;
      color: $active-color;
      font-size: 12px;
      letter-spacing: 0.2em;
      text-align: left;
      padding: 0 20px;
    }

    .upload {
      width: 180px;
      border-radius: 0 4px 4px 0;
      margin-left: 0;

      input {
        display: none;
      }
    }

    .button + .button {
      margin-left: 0;
    }
  }
}
</style>
